import type { ClientHandler } from '../../../types/client-handler';
import { CATEGORY_IMAGES } from '../../../clients/HIPOTECARIO/_shared/data/category-images';
import { DISCOUNT_IMAGES } from '../../../clients/HIPOTECARIO/_shared/data/discount-images';
import { buildLegalText, toLegalDate } from '../../../clients/HIPOTECARIO/_shared/data/legal-text';

export const hipotecarioHandler: ClientHandler = {
  // Deriva valores de campos que no están en el form (imágenes de categoría/descuento y el
  // texto legal): el binder toma su valor de acá (defaults) y los pinta con su effect.
  computeDefaults: formData => {
    const defaults: Record<string, string> = {};

    const category = formData['benefit-category'];
    if (typeof category === 'string') defaults['benefit-category-image'] = CATEGORY_IMAGES[category] ?? '';

    const discount = formData['discount-value'];
    if (typeof discount === 'string') defaults['discount-value-image'] = DISCOUNT_IMAGES[discount] ?? '';

    // legal-text: texto fijo con las fechas insertadas (el usuario solo elige las fechas).
    const from = formData['legal-date-from'];
    const to = formData['legal-date-to'];
    if (typeof from === 'string' && typeof to === 'string') {
      defaults['legal-text'] = buildLegalText(toLegalDate(from), toLegalDate(to));
    }

    return defaults;
  },

  // El picker de logos solo aplica cuando stores-section está en modo grilla.
  shouldShowField: (fieldKey, formData) => {
    if (fieldKey !== 'stores-grid') return true;
    const section = formData['stores-section'];
    const variant = section && typeof section === 'object' ? (section as { variant?: string }).variant : undefined;
    return variant === 'grid';
  }
};
